/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsProjectSortCriteria {
    getFixupPrototypeFunction() { return AppSecopsProjectSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsProjectSortCriteria>): AppSecopsProjectSortCriteria {
        let obj = Object.assign(new AppSecopsProjectSortCriteria(), model);
        AppSecopsProjectSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsProjectSortCriteria>): AppSecopsProjectSortCriteria {
        if (!model) return null;
        return AppSecopsProjectSortCriteria.newInstance(<AppSecopsProjectSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsProjectSortCriteria) {
        if (!obj) return;

        models.AppSecopsProjectSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsProjectSortCriteria): boolean {
        Object.setPrototypeOf(obj, AppSecopsProjectSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.AppSecopsProjectSortColumn;

    ascending: boolean;

}
